module.exports = __webpack_public_path__ + "img/newstitle.bb83ebc4.png";